import React, { useContext, useEffect, useState } from 'react'
import { Card, CardHeader, CardBody, Image, useDisclosure } from "@nextui-org/react";
import ModalComponent from './ModalComponent';
import { UserContext } from '../App';

const CardComponent = ({ whiskey, ratings, comments, setRatings }) => {

    // const [rating, setRating] = useState(0);
    const year = new Date().getFullYear()
    const month = new Date().getMonth() + 1
    const day = new Date().getDate().toString().padStart(2, "0")
    // let currentDate
    const [currentDate, setCurrentDate] = useState(year + "-" + month + "-" + day)
    // const currentDate = "2025-12-24"
    const compareDate = new Date(whiskey.date.seconds * 1000).toLocaleDateString('sv-se')
    const compareDateDigit = new Date(whiskey.date.seconds * 1000).getDate()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const user = useContext(UserContext)
    const [admin, setAdmin] = useState(false)
    const [rating, setRating] = useState(1);
    const [ratings1, setRatings1] = useState([])
    const [ratings2, setRatings2] = useState([])
    const [ratings3, setRatings3] = useState([])

    useEffect(() => {
        checkUser(user.id, currentDate)
        calculateOverallRatingAndComments(ratings)

    }, [user.id, currentDate, ratings])


    const handleOpen = (e) => {
        onOpen();
    }

    const calculateOverallRatingAndComments = (_ratings) => {
        let amountOfVoters = _ratings.filter(r => r.type === 1).length + _ratings.filter(r => r.type === 2).length + _ratings.filter(r => r.type === 3).length
        let score = _ratings.reduce((partialSum, a) => partialSum + a.score, 0)
        setRating(Math.round(score / amountOfVoters * 10) / 10)
        setRatings1(_ratings.filter(r => r.type === 1))
        setRatings2(_ratings.filter(r => r.type === 2))
        setRatings3(_ratings.filter(r => r.type === 3))



    }


    const checkUser = (id, _currentDate) => {
        switch (id) {
            case "HbGLekLlnOxnCgo9pyKm":
                setAdmin(true)
                setCurrentDate("2025-12-24")
                break;
            case "YWmtbnBjE2tPD5NtwhPH":
                setAdmin(true)
                setCurrentDate("2025-12-24")
                break;
            case "8RL5326BULZsyOZPf04w":
                setAdmin(true)
                setCurrentDate("2025-12-24")
                break;

            default:
                setAdmin(false)
                setCurrentDate(year + "-" + month + "-" + day)
                break;
        }
    }

    // const handleRatingChange = (newRating) => {
    //     if (newRating >= 1 && newRating <= 5) {
    //         setRating(newRating);
    //     }
    // };

    return (
        <div onClick={handleOpen} className=' w-full'>

            <Card className="position-relative py-4 w-full cursor-pointer hover:bg-zinc-100 dark:hover:bg-slate-800  card-size justify-center content-center animate__animated animate__fadeInLeft" >
                <span style={currentDate >= compareDate && user.id ? { backgroundImage: `url(${whiskey.originImage})`, backgroundSize: `cover` } : {}} className={` leading-none ${currentDate < compareDate || !user.id ? `text-zinc-950 dark:text-neutral-200 opacity-50 background-number ${compareDateDigit >= 10 && 'double-digit'}` : `text-transparent bg-clip-text background-number ${compareDateDigit > 9 && 'double-digit'}`} `}>{compareDateDigit}</span>
                {admin && <ModalComponent isOpen={isOpen} onClose={onClose} whiskey={whiskey} user={user} />}
                {currentDate >= compareDate && user.id && <><ModalComponent isOpen={isOpen} onClose={onClose} whiskey={whiskey} user={user} rating={rating} setRating={setRating} ratings1={ratings1} ratings2={ratings2} ratings3={ratings3} calculateOverallRatingAndComments={calculateOverallRatingAndComments} setRatings={setRatings} ratings={ratings} />
                    <CardHeader className="pb-0 pt-0 px-4 flex-col items-start">
                        {/* <p className="text-tiny uppercase font-bold">{whiskey.date} December</p> */}
                        <small className="text-gray-600">{whiskey.origin}</small>
                        <h4 className={`font-bold ${whiskey.name.length > 25 ? "text-sm" : "text-lg"}`}>{whiskey.name}</h4>
                        <h6 className="font-light text-gray-400 text-small">{whiskey.subName}</h6>
                    </CardHeader>
                    <CardBody className="overflow-visible py-2 gap-2 justify-center items-center">
                        <Image
                            alt="Card background"
                            className="object-contain h-48 rounded-xl"
                            src={whiskey.image}
                            width={270}
                        />



                        <h2 className='self-start'>Betyg</h2>
                        <div className='flex gap-1 md:gap-3 self-start justify-between w-full'>
                            <span>{!rating ? "-" : rating} / 5</span>
                            {comments.length > 0 && <span><i className="fa-solid fa-comments mr-2"></i>{comments.length}</span>}
                        </div>
                    </CardBody></>}

            </Card>
        </div>
    )
}

export default CardComponent